import React from 'react';

import CheatSheet from '../components/CheatSheet/CheatSheet';

function PorPara() {
  return (
    <CheatSheet title='Por and Para'>
      <p>Coming soon.</p>
    </CheatSheet>
  );
}

export default PorPara;
